__turbopack_context__.v({
  "appear-slide-left": "ContactForm-module-scss-module__taHw8a__appear-slide-left",
  "bounceTwice": "ContactForm-module-scss-module__taHw8a__bounceTwice",
  "checkbox": "ContactForm-module-scss-module__taHw8a__checkbox",
  "checkboxLabel": "ContactForm-module-scss-module__taHw8a__checkboxLabel",
  "error": "ContactForm-module-scss-module__taHw8a__error",
  "fade-in-bottom": "ContactForm-module-scss-module__taHw8a__fade-in-bottom",
  "fade-in-left": "ContactForm-module-scss-module__taHw8a__fade-in-left",
  "fade-in-right": "ContactForm-module-scss-module__taHw8a__fade-in-right",
  "fadeIn": "ContactForm-module-scss-module__taHw8a__fadeIn",
  "form": "ContactForm-module-scss-module__taHw8a__form",
  "formGroup": "ContactForm-module-scss-module__taHw8a__formGroup",
  "icon": "ContactForm-module-scss-module__taHw8a__icon",
  "input": "ContactForm-module-scss-module__taHw8a__input",
  "loader": "ContactForm-module-scss-module__taHw8a__loader",
  "puff-in-center": "ContactForm-module-scss-module__taHw8a__puff-in-center",
  "puff-in-left": "ContactForm-module-scss-module__taHw8a__puff-in-left",
  "pulse": "ContactForm-module-scss-module__taHw8a__pulse",
  "pulse-contact": "ContactForm-module-scss-module__taHw8a__pulse-contact",
  "shake-bottom": "ContactForm-module-scss-module__taHw8a__shake-bottom",
  "slide-again": "ContactForm-module-scss-module__taHw8a__slide-again",
  "slide-in-right": "ContactForm-module-scss-module__taHw8a__slide-in-right",
  "srOnly": "ContactForm-module-scss-module__taHw8a__srOnly",
  "stepContent-entrance": "ContactForm-module-scss-module__taHw8a__stepContent-entrance",
  "submitButton": "ContactForm-module-scss-module__taHw8a__submitButton",
  "textarea": "ContactForm-module-scss-module__taHw8a__textarea",
});
